import { COLLECT_COUPON, DISPLAY_COUPON_POPUP, GET_COUPONS, STORE_COUPON, GET_COUPON_URL, GET_COUPON_USAGE, DISPLAY_COUPON_LIST_POPUP, GET_USER_COUPONS, GET_USABLE_COUPONS} from './type';
import _ from 'lodash';

export function collectCoupon(user_id, promo_id){
    return (dispatch, getState, {axios}) => {
        dispatch({
            type: COLLECT_COUPON,
            payload: false
        })
        axios.post(`/api/collect_coupon`, {
            obj : {
                user_id : user_id,
                promo_id : promo_id,
                status : '01'
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch({
                type: COLLECT_COUPON,
                payload: response.data
            })
        })
        .catch((error) => {
            dispatch({
                type: COLLECT_COUPON,
                payload: false
            })
        })
    }
}

export function displayCouponPopup(visible, coupon=null){
    return (dispatch, getState, {axios}) => {
        dispatch({
            type: DISPLAY_COUPON_POPUP,
            payload: {visible : true, coupon: coupon}
        })
    }
}

export function getUserCoupons(filter={}, sort= {}, page=1){
    return (dispatch, getState, {axios}) => {
        // axios.post(`/api/user/coupons`, {
        dispatch({
            type: GET_USER_COUPONS,
            payload: null
        })
        axios.post(`/api/get_user_coupons`, {
            filter : filter,
            sort : sort,
            page : page,
            option : {
                user_id : getState().prof.profile? getState().prof.profile.user_id: null
            }
        })
        .then((response) => {
            dispatch({
                type: GET_USER_COUPONS,
                payload: response.data
            })
        })
        .catch((error) => {
            dispatch({
                type: GET_USER_COUPONS,
                payload: false
            })
        })
    }
}

export function storeCouponAuth(coupon) {
    return (dispatch) => {
        dispatch({
            type: STORE_COUPON,
            payload: coupon
        })
    }
}

export function getCouponFromUrl(promo_code) {
    return (dispatch) => {
        dispatch({
            type: GET_COUPON_URL,
            payload: promo_code
        })
    }
}

export function getCouponUsage(coupons) {
    return (dispatch, getState, {axios}) => {
        return new Promise((resolve, reject) => {
            axios.post('/coupon/usage', {
                coupons
            }).then((response) => {
                dispatch({
                    type: GET_COUPON_USAGE,
                    payload: response.data
                })
                resolve()
            })
        })
    }
    
}

export function getCoupons(filter={}, sort= {}, page=1){
    return (dispatch, getState, {axios}) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/get_coupons`, {
                filter : filter,
                sort : sort,
                page : page,
                option : {
                    user_id : getState().prof.profile? getState().prof.profile.user_id: null
                }
            })
            .then((response) => {
                dispatch({
                    type: GET_COUPONS,
                    payload: response.data
                })
                resolve()
            })
            .catch((error) => {
                dispatch({
                    type: GET_COUPONS,
                    payload: false
                })
                resolve()
            })
        })
        
    }
}

export function setCouponListDisplay(display){
    return (dispatch) => {
        dispatch({
            type: DISPLAY_COUPON_LIST_POPUP,
            payload: display
        })
    }
}

export function getUserUsableCoupons(items, list , selected=[]){
    return (dispatch, getState, {axios}) => {
        const tmp_items = [];
        _.map(items, (item, index) => {
            _.times(item.quantity? ((item.quantity < 0)? 0: item.quantity): 1, (n) => {
                tmp_items.push({
                    mat_var_id: item.mat_var_id
                });
            })
        });
        // axios.post(`/api/user/coupons`, {
        axios.post(`/coupon_list`, {
            items : tmp_items,
            promo_select : selected,
            promo_list : list
        })
        .then((response) => {
            dispatch({
                type: GET_USABLE_COUPONS,
                payload: response.data
            })
        })
        .catch((error) => {
            dispatch({
                type: GET_USABLE_COUPONS,
                payload: false
            })
        })
    }
}
